import type { CookieConsentLevelsEnum } from 'utils/constants/consentLevels';
import { getServiceSettings } from 'utils/getServiceSettings';

import { CookieConsentService } from '@inter-ikea-kompis/services';

let service: CookieConsentService;

const getService = () => {
  if (!service) {
    service = new CookieConsentService({ ...getServiceSettings() });
  }

  return service;
};

export const hasCookieConsent = (consentLevel: CookieConsentLevelsEnum) => {
  return getService().hasCookieConsent(consentLevel);
};
